import { z } from 'zod';
export const meetingEventRoleAssignmentCreateSchema = z.object({
    userId: z.number({ message: 'User ID is required' }),
    meetingBodyRoleIds: z.array(z.number()).min(1, { message: 'At least one role is required' }),
});
export const meetingEventRoleAssignmentUpdateSchema = z.object({
    meetingBodyRoleId: z.number({ message: 'Meeting body role ID is required' }),
});
